<div class="cx-section">
  @if ((addresses$ | async).length) {
    @if (!(addressesStateLoading$ | async)) {
      <div class="row cx-address-deck"
        >
        @for (address of addresses$ | async; track address) {
          <div
            class="col-md-6 cx-address-card">
            <app-efa-card [border]="true"
              [fitToContainer]="true"
              [content]="getAddressCardContent(address) | async"
              (editCard)="editAddressButtonHandle(address)"
              (setDefaultCard)="setAddressAsDefault(address)"
              (deleteCard)="setEdit(address.id)"
              [editMode]="address.id === editCard"
            (cancelCard)="cancelCard()"></app-efa-card>
          </div>
        }
      </div>
    } @else {
      <div class="col-md-12 cx-address-spinner">
        <cx-spinner></cx-spinner>
      </div>
    }
  } @else {
    <div class="noAddresses">{{ 'efaAddressBook.noAddresses' | cxTranslate }}</div>
  }
</div>


